import { render, staticRenderFns } from "./AssistenciaFuneral.vue?vue&type=template&id=c2e70fd4&scoped=true&"
import script from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
export * from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
import style0 from "./AssistenciaFuneral.vue?vue&type=style&index=0&id=c2e70fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e70fd4",
  null
  
)

export default component.exports